import styled from 'styled-components';

export const List = styled.ol`
    list-style: none;
    margin: 0;
    padding: 0;
`;

export const DividerContainer = styled.li`
    display: flex;
    align-items: center;
    height: 30px;
    background-color: #eff1f3;
    color: #6d767d;
    border-radius: 4px;
    padding: 0 8px;
`;

export const InfoEditButtonContainer = styled.div`
    margin-left: auto;
`;

export const RowContainer = styled.li<{ border: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: ${props => (props.border ? '1px solid #e0e1df' : 'none')};
    gap: 20px;
    min-height: 30px;
    max-height: 90px;
    overflow: auto;
    padding: 4px 8px;
`;
